import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { arrayOf, shape, bool, string, oneOfType, number } from 'prop-types';
import ProductList from '../../ProductList';
import HighlightTitle from '../highlight-title';

const Rank = _ref => {
  let {
    data,
    title,
    titleAs,
    titleSize,
    imageAltPrefix,
    productTitleAs,
    showDiscountOnlyCashInfo,
    showDiscount
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["data", "title", "titleAs", "titleSize", "imageAltPrefix", "productTitleAs", "showDiscountOnlyCashInfo", "showDiscount"]);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HighlightTitle, {
    title: title,
    titleSize: titleSize,
    titleAs: titleAs
  }), /*#__PURE__*/React.createElement(ProductList, _extends({
    data: data,
    displayMode: "list",
    enableShadow: false,
    exhibition: "rank",
    imageAltPrefix: imageAltPrefix,
    titleAs: productTitleAs,
    showInCashInfo: true,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    showDiscount: showDiscount
  }, props)));
};

process.env.NODE_ENV !== "production" ? Rank.propTypes = {
  displayMode: string,
  data: arrayOf(shape),
  title: string,
  titleAs: string,
  titleSize: oneOfType([string, number]),
  imageAltPrefix: string,
  productTitleAs: string,
  showDiscountOnlyCashInfo: bool,
  showDiscount: bool
} : void 0;
export default Rank;